var render, staticRenderFns
import script from "./PopBox.vue?vue&type=script&lang=js&"
export * from "./PopBox.vue?vue&type=script&lang=js&"
import style0 from "./PopBox.vue?vue&type=style&index=0&id=3c56c88e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c56c88e",
  null
  
)

export default component.exports